export default __webpack_public_path__ + "static/media/iOS-app-Header.e16ce850.png";